import React, { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./irma.css";
import logo from "../../../../logo1.jpg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import testLogo from "./Asset 2.png";
// import graph from "./graph.png";
import { Select, MenuItem, TextField, TableCell, TableHead, TableBody, Table } from '@material-ui/core';
import moment from "moment";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import NpsRating from "../../NPS";
const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
        tableCell: {
            padding: 2,
            height: 40,
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const JakReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const [uuid, setUuid] = useState<any>("");
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);

    //Report Data
    const [jak, setjak] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setjak(data);
    }, [reportListParameter])


    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])


    //Booking Data
    const [jakReport, setjakReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setjakReport(data);
    }, [reportListParameter])


    useEffect(() => {
        setSample_Collected(jakReport[0]?.collection_date);
        setSample_Receivedtime(jakReport[0]?.pickup_time);
        setdesignation(jakReport[0]?.designation);
        setGender(jakReport[0]?.customer_gender);
        setSample_Received(jakReport[0]?.pickup_date);
        setName(jakReport[0]?.customer_name);
        setAge(jakReport[0]?.customer_age);
        setDob(jakReport[0]?.dob);
        setUuid(jakReport[0]?.uuid);
    }, [jakReport]);

    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);

        }
        else {

            setAge(jakReport[0]?.customer_age);
        }
    }, [dob]);


    const [jakMethology, setjakMethology] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.methodology &&
            reportListParameter?.methodology.length > 0
        ) {
            reportListParameter?.methodology?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setjakMethology(data);
    }, [reportListParameter]);


    //Gene
    const [gene, setGene] = useState<any>([]);
    useEffect(() => {
        const brcaclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.gene &&
            reportListParameter?.gene?.length > 0
        ) {
            reportListParameter?.gene?.map((list: any) => {
                brcaclincdata?.push({ ...list });
            });
        }
        setGene(brcaclincdata);
    }, [reportListParameter]);

    const updateGene = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...gene]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setGene(storeData);
    }

    //Varint
    const [varientData, setVarient] = useState<any>([]);
    useEffect(() => {
        const brcaclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.variant &&
            reportListParameter?.variant?.length > 0
        ) {
            reportListParameter?.variant?.map((list: any) => {
                brcaclincdata?.push({ ...list });
            });
        }
        setVarient(brcaclincdata);
    }, [reportListParameter]);

    const updateVarient = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...varientData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setVarient(storeData);
    }

    //zygosityDta
    const [zygosityData, setZygosity] = useState<any>([]);
    useEffect(() => {
        const brcaclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.zygosity &&
            reportListParameter?.zygosity?.length > 0
        ) {
            reportListParameter?.zygosity?.map((list: any) => {
                brcaclincdata?.push({ ...list });
            });
        }
        setZygosity(brcaclincdata);
    }, [reportListParameter]);

    const updateZygosity = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...zygosityData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setZygosity(storeData);
    }

    //disoreder
    const [disorderData, setDisorder] = useState<any>([]);
    useEffect(() => {
        const brcaclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.disorder &&
            reportListParameter?.disorder?.length > 0
        ) {
            reportListParameter?.disorder?.map((list: any) => {
                brcaclincdata?.push({ ...list });
            });
        }
        setDisorder(brcaclincdata);
    }, [reportListParameter]);

    const updateDisorder = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...disorderData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setDisorder(storeData);
    }

    //Hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }

    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }

    // Hospital Id

    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }


    //doctor list
    const [jakdoctorList, setjakdoctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setjakdoctorList(data);
    }, [reportListParameter]);

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...jakdoctorList]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setjakdoctorList(storeData);
    }


    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }


    //clinical Significance
    const [clinicalInformation, setClinicalInformation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_indication
            &&
            reportListParameter?.clinical_indication
                .length > 0
        ) {
            reportListParameter?.clinical_indication
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setClinicalInformation(data);
    }, [reportListParameter]);

    const updateClinicalInformation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicalInformation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicalInformation(storeData);
    }
    // positive Negative
    const [brcaPositiveNegative, setPositiveNegative] = useState<any>([]);
    useEffect(() => {
        const brcaclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.brca_positive_negative &&
            reportListParameter?.brca_positive_negative?.length > 0
        ) {
            reportListParameter?.brca_positive_negative?.map((list: any) => {
                brcaclincdata?.push({ ...list });
            });
        }
        setPositiveNegative(brcaclincdata);
    }, [reportListParameter]);

    const updatePosiveNegative = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...brcaPositiveNegative]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setPositiveNegative(storeData);
    }
    // brca result value
    const [resultValue, setResultValue] = useState<any>([]);
    useEffect(() => {
        const brcaresultvaluedata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.brac_result_value &&
            reportListParameter?.brac_result_value?.length > 0
        ) {
            reportListParameter?.brac_result_value?.map((list: any) => {
                brcaresultvaluedata?.push({ ...list });
            });
        }
        setResultValue(brcaresultvaluedata);
    }, [reportListParameter]);

    const updateResultValue = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...resultValue]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setResultValue(storeData);
    }



    //varient 1
    const [varient1, setVarient1] = useState<any>([]);
    useEffect(() => {
        const brcaclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.variant_information &&
            reportListParameter?.variant_information?.length > 0
        ) {
            reportListParameter?.variant_information?.map((list: any) => {
                brcaclincdata?.push({ ...list });
            });
        }
        setVarient1(brcaclincdata);
    }, [reportListParameter]);

    const updateVarientInformation1 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...varient1]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setVarient1(storeData);
    }

    // Qc metrics 
    let metricsData = [
        {
            id: 1,
            name: "Homozygous mutation detected",
            val: "Both copies of the gene carry mutation",
        },
        {
            id: 2,
            name: "Heterozygous mutation detected",
            val: "One copy of the gene carries mutation",
        },
        {
            id: 3,
            name: "Not detected",
            val: "Mutation not detected",
        },
    ];

    const [qcmetricsResults, setQcMetricsResults] = useState<any>([])
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.qc_metrics &&
            reportListParameter?.qc_metrics.length > 0
        ) {
            reportListParameter?.qc_metrics?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setQcMetricsResults(data);
        // data?.length === 0 ? setQcMetrics(metricsData) : setQcMetrics(data);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([])
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.qc_metrics &&
            reportListParameter?.qc_metrics.length > 0
        ) {
            data = reportListParameter?.qc_metrics[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            } else {
                metricsData?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }

        setTableData(storeData);

    }, [reportListParameter]);

    const updateMetricsData = (
        index: number,
        key: string,
        value: any,
        object: any
    ) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "val":
                newItem.val = value;
                break;
        }
        storeData[index] = newItem;
        setTableData(storeData);
    };


    //Submit Data

    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (jakReport.length > 0) {
            jakReport?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (clinicalInformation.length > 0) {
            clinicalInformation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }


        if (jakdoctorList.length > 0) {
            jakdoctorList?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (jak.length > 0) {
            jak?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        const stringify = JSON.stringify(tableData);
        if (qcmetricsResults.length > 0) {
            qcmetricsResults?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        if (gene.length > 0) {
            gene?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (varientData.length > 0) {
            varientData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (zygosityData.length > 0) {
            zygosityData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (disorderData.length > 0) {
            disorderData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (resultValue.length > 0) {
            resultValue?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (brcaPositiveNegative.length > 0) {
            brcaPositiveNegative?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (varient1.length > 0) {
            varient1?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }
    };

    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
    const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])
    const documentTitle = `${jakReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="page-headers1">
                        <div style={{ padding: "5px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}

                            >
                                <div style={{ width: "100%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <img src={logo} alt="logo" style={{ width: "100% " }} />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="main-contain-section"> */}
                    <div className="main-content3">.</div>
                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "25px", marginTop: "10px" }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="marginLeft-c">
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {jakReport[0]?.pk
                                                ? jakReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :  <input
                                                className="input"

                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}

                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : 'NA'}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <>
                                            <Grid item xs={3.5}>
                                                Age
                                            </Grid>
                                            {dob === "" || dob === null ? (
                                                <Grid item xs={8.5}>
                                                    :  <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                </Grid>
                                            )
                                                : (
                                                    <Grid item xs={8.5} style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}>
                                                        : {age} Y
                                                    </Grid>
                                                )}
                                        </>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {jakReport[0]?.center?.name && jakReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :  <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                value={Gender}
                                                onChange={(e) => setGender(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="normal">NA</option>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="ffpe tissue block"> FFPE TISSUE BLOCK </option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            :<input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            :<input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    <div style={{ width: "96%", marginLeft: "25px" }}>
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Report:-{jakReport[0]?.packages[0]?.name && jakReport[0]?.packages[0]?.name.toUpperCase()}</h6>
                    </div>
                    <hr style={{ width: "95%" }}></hr>
                    {/* clinical indication  */}
                    <div style={{ width: "96%", marginLeft: "20px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "-1px", padding: "8px" }} className="clinical__subheadin">CLINICAL INFORMATION</h6>
                    </div>
                    <div>
                        {clinicalInformation?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "25px" }}
                                            rows={3}
                                            cols={138}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateClinicalInformation(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>


                    <div style={{ width: "96%", marginLeft: "14px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "4px", padding: "8px" }} className="clinical__subheadin">RESULT SUMMARY</h6>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            background: "#fff",
                            padding: "6px",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                textAlign: "left",
                                marginBottom: "10px",
                            }}
                        >
                            {resultValue?.map((list: any, index: number) => {
                                const parameterValue = list?.parameter_value.toLowerCase();
                                let textColor;

                                if (parameterValue === 'positive' || parameterValue.startsWith('po')) {
                                    textColor = 'red';
                                } else if (parameterValue === 'negative' || parameterValue.startsWith('ne')) {
                                    textColor = 'green';
                                } else {
                                    textColor = '';
                                }

                                return (
                                    <div
                                        style={{
                                            width: "45%",
                                            padding: 15,
                                            textAlign: "center",
                                            marginTop: "-15px",
                                            fontSize: "16px",
                                            color: textColor
                                        }}
                                    >
                                        <textarea
                                            style={{
                                                border: "none",
                                                resize: "none",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                color: textColor
                                            }}
                                            rows={2}
                                            cols={126}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateResultValue(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </div>
                                );
                            })}

                            {/* {brcaPositiveNegative?.map((list: any, index: number) => {
                                const parameterValue = list?.parameter_value.toLowerCase();
                                let textColor;

                                if (parameterValue === 'positive') {
                                    textColor = 'red';
                                } else if (parameterValue === 'negative') {
                                    textColor = 'green';
                                } else {
                                    textColor = 'defaultColor';
                                }

                                return (
                                    <div
                                        style={{
                                            width: "45%",
                                            padding: 15,
                                            textAlign: "center",
                                            marginTop: "-15px",
                                            fontSize: "16px",
                                            color: textColor
                                        }}
                                    >
                                        <textarea
                                            style={{
                                                border: "none",
                                                resize: "none",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                color: textColor
                                            }}
                                            rows={2}
                                            cols={126}
                                            value={list?.parameter_value}
                                            onChange={(e) => updatePosiveNegative(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </div>
                                );
                            })} */}
                        </div>
                    </div>


                    <div style={{ width: "97%", marginLeft: "10px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "4px", padding: "8px" }} className="clinical__subheadin">KEY FINDING</h6>
                    </div>
                    <div className="grid-table1" style={{ width: "99%" }} >
                        <div className="table-header-a">Gene Transcript</div>
                        <div className="table-header-a">Mutation Detected Status</div>
                        <div className="table-header-a">Mutation Finding</div>
                        <div className="table-header-a">Relevance</div>
                        {gene?.map((list: any, index: number) => {
                            return (
                                <textarea
                                    className="table-row-a"
                                    defaultValue={list?.parameter_value}
                                    onChange={(e: any) => {
                                        updateGene(list?.id, e.currentTarget.value, index, "free_text", list);
                                    }}
                                    rows={3}
                                    style={{
                                        // unicodeBidi: 'plaintext',
                                        textAlign: 'center',
                                        resize: "none",
                                        borderColor: "black",
                                        height: "85px",
                                    }}
                                />
                            )
                        })
                        }
                        {disorderData?.map((list: any, index: number) => {
                            return (
                                <textarea
                                    className="table-row-a"
                                    defaultValue={list?.parameter_value}
                                    onChange={(e: any) => {
                                        updateDisorder(list?.id, e.currentTarget.value, index, "free_text", list);
                                    }}
                                    rows={3}
                                    style={{ textAlign: 'center', resize: "none", borderColor: "black" }}
                                />
                            )
                        })
                        } {varientData?.map((list: any, index: number) => {
                            return (
                                <textarea
                                    className="table-row-a"
                                    defaultValue={list?.parameter_value}
                                    onChange={(e: any) => {
                                        updateVarient(list?.id, e.currentTarget.value, index, "free_text", list);
                                    }}
                                    rows={3}
                                    style={{ textAlign: 'center', resize: "none", borderColor: "black" }}
                                />
                            )
                        })
                        }
                        {zygosityData?.map((list: any, index: number) => {
                            return (
                                <textarea
                                    className="table-row-a"
                                    defaultValue={list?.parameter_value}
                                    onChange={(e: any) => {
                                        updateZygosity(list?.id, e.currentTarget.value, index, "free_text", list);
                                    }}
                                    rows={3}
                                    style={{ textAlign: 'center', resize: "none", borderColor: "black" }}
                                />
                            )
                        })
                        }
                    </div>
                    <div style={{ width: "97%", marginLeft: "10px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "4px", padding: "8px" }} className="clinical__subheadin">DETAILED RESULT INFORMATION</h6>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            margin: "10px 0px",
                            textAlign: "start",
                            marginTop: "-19px",
                            padding: "5px",
                        }}
                    >

                        <div style={{ width: "99%", marginLeft: 5 }}
                        >
                            {varient1?.map((list: any, index: number) => {
                                return (
                                    <div style={{ width: "99%", padding: 15, textAlign: "left", fontSize: "15px" }}>
                                        <GrammarlyEditorPlugin>
                                            <textarea
                                                style={{ border: "none", resize: "none" }}
                                                rows={4}
                                                cols={139}
                                                value={list?.parameter_value}
                                                onChange={(e) => updateVarientInformation1(list?.id, e.target.value, index, "free_text", list)}
                                            />
                                        </GrammarlyEditorPlugin>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div style={{ display: "flex", width: "99%", borderRadius: "5px", marginTop: "-20px", marginLeft: "9px" }} className="clinical__subheadin">
                        <table style={{ width: "99%", border: "1px solid black", background: "#f0f5f1" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "49.7%", textAlign: "left", fontWeight: "bold", fontSize: "18px", borderRight: "1px solid black" }}>Result Classification</th>
                                    <th style={{ width: "49.9%", textAlign: "left", fontWeight: "bold", fontSize: "18px" }}>Comment</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div
                        style={{
                            width: "98%",
                            display: "flex",
                            border: "1px solid",
                            color: "#1A5276",
                            borderRadius: "5px",
                            borderStyle: "solid",
                            marginLeft: "9px",
                        }}
                    >
                        <div style={{ width: "99%", marginLeft: 5, }}>
                            <Table>
                                <colgroup>
                                    <col style={{ width: '49.5%' }} />
                                    <col style={{ width: '49.5%' }} />
                                </colgroup>
                                <TableHead>
                                </TableHead>
                                {tableData?.length > 0 &&
                                    tableData?.map((list: any, index: number) => {
                                        return (
                                            <>
                                                <TableBody key={index}>
                                                    <TableCell className={classes.tableCell} align="left" style={{ borderRight: "1px solid black" }}>
                                                        <GrammarlyEditorPlugin>
                                                            <input
                                                                style={{ border: "none", textAlign: "left", width: "100%", background: "none" }}
                                                                value={list?.name}
                                                                onChange={(e: any) =>
                                                                    updateMetricsData(
                                                                        index,
                                                                        "name",
                                                                        e.target.value,
                                                                        list
                                                                    )
                                                                }
                                                            />
                                                        </GrammarlyEditorPlugin>
                                                    </TableCell>
                                                    <TableCell
                                                        className={classes.tableCell}
                                                        align="center"
                                                        style={{ borderLeft: "1px solid black" }}
                                                    >
                                                        <GrammarlyEditorPlugin>
                                                            <input
                                                                style={{ border: "none", textAlign: "left", width: "100%", background: "none" }}
                                                                value={list?.val}
                                                                onChange={(e: any) =>
                                                                    updateMetricsData(
                                                                        index,
                                                                        "val",
                                                                        e.target.value,
                                                                        list
                                                                    )
                                                                }
                                                            />
                                                        </GrammarlyEditorPlugin>
                                                    </TableCell>
                                                </TableBody>

                                            </>
                                        );
                                    })}
                            </Table>
                        </div>
                    </div >
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div className="bodyMargin1">.</div>
                    <div style={{ marginLeft: "8px", padding: "3px", background: "#EEEEEE", borderRadius: "0px 10px", width: "730px", height: "30px", marginTop: "-20px" }}>
                        <h6> Patient Name: &nbsp;
                            {jakReport[0]?.designation}&nbsp;
                            {jakReport[0]?.customer_name} &nbsp;&nbsp;&nbsp;Booking Id:&nbsp;{jakReport[0]?.pk} </h6>
                    </div>
                    <div style={{ width: "97%", marginLeft: "10px", marginTop: "17px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "4px", padding: "8px" }} className="clinical__subheadin">CLINICAL SIGNIFICANCE</h6>
                    </div>
                    <br />
                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "20px", fontSize: "18px" }}>
                        {brcaPositiveNegative?.map((list: any, index: number) => {
                            return (
                                <textarea
                                    style={{ border: "none", resize: "none" }}
                                    rows={6}
                                    cols={117}
                                    defaultValue={list?.parameter_value}
                                    onChange={(e: any) => {
                                        updatePosiveNegative(list?.id, e.currentTarget.value, index, "free_text", list);
                                    }}
                                />
                            )
                        })
                        }
                    </div>
                    <div style={{ width: "97%", marginLeft: "10px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "4px", padding: "8px" }} className="clinical__subheadin">CLINICAL INTERPRETATION</h6>
                    </div>
                    <br />
                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "20px", fontSize: "18px" }}>
                        The BC R/ABL 1 gene translocation or t(9:22) is found in more than 95% of CML patients, 5% of pediatric AL L -
                        B CAL L A positive & 15-30% of adult AL L -B CAL L A positive patients. The identification of this translocation
                        stratifies patients that respond to and benefit from T yrosine K inase Inhibitor (TK I) therapy. However, a significant
                        minority (5-15%) of patients on treatment may develop secondary resistance to TK Is. The most common
                        mechanism of development of resistance is the emergence of point mutations in the ABL 1 kinase domain of the
                        BC R/ABL 1 transcript that interfere with Imatinib binding. Patients that exhibit Failure of TK I treatment (as per
                        EL N guidelines) or show an increase of more than 1log in the BC R/ABL 1 transcript level should be evaluated for
                        the presence of mutations. Identification of the exact mutation is clinically relevant so that the most effective
                        Second generation TK I may be chosen for further treatment.
                    </div>

                    <div style={{ width: "97%", marginLeft: "10px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "4px", padding: "8px" }} className="clinical__subheadin">TEST DESCRIPTION</h6>
                    </div>
                    <br />
                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "20px", fontSize: "18px" }}>
                        This nested RT-PCR and sequencing of the BCR-ABL1 fusion transcript for qualitative detection of mutations
                        associated with resistance to Gleevec (imatinib) and other tyrosine kinase inhibitors. Analysis includes detection
                        of all mutations recommended by guidelines, including the common mutation as T315I, Y253H, E255K/V,
                        F359V/C/I, F317L /V/I/C, T315A, and V299L . This assay is uses RNA for cDNA synthesis followed by Nested PCR
                        and Sanger sequencing. This test was developed and its analytical performance characteristics have been
                        determined by Redcliffe labs. It has not been cleared or approved by FDA.
                    </div>

                    <div style={{ width: "97%", marginLeft: "10px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "4px", padding: "8px" }} className="clinical__subheadin">TEST LIMITATIONS</h6>
                    </div>
                    <br />
                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "20px", fontSize: "18px" }}>
                        <ul>
                            <li>
                                <p>This test is performed on Nested RT-PCR followed by Sanger Sequencing. The analytical sensitivity of the test
                                    allows detection of the mutation when the mutant clone comprises at least 18-20% of the total hybrid transcript.</p>
                            </li>
                            <li>
                                <p>
                                    Test is RNA-based,samples must be received at the laboratory under cool-pack conditions (4-8 °C) within 48 hrs of
                                    collection to ensure preservation of intact RNA.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Test results may vary if appropriate sample collection and transportation to lab not followed as per protocol.
                                </p>
                            </li>
                        </ul>
                    </div>
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div className="bodyMargin2">.</div>
                    {/* <div className="bodyMargin2 ">.</div> */}
                    <div style={{ marginLeft: "8px", padding: "3px", background: "#EEEEEE", borderRadius: "0px 10px", width: "730px", height: "30px" }}>
                        <h6> Patient Name: &nbsp;
                            {jakReport[0]?.designation}&nbsp;
                            {jakReport[0]?.customer_name} &nbsp;&nbsp;&nbsp;Booking Id:&nbsp;{jakReport[0]?.pk} </h6>
                    </div>
                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "20px", fontSize: "18px" }}>
                        <br />
                        <ul>
                            <li>
                                <p>
                                    This test is laboratory developed and its performance were evaluated at Redcliffe Labs.
                                </p>
                            </li>
                            <li>
                                <p>
                                    It should be noted that test is limited to a ABL1 Kinase Domain of BCR-ABL1 transcript only and it predicts
                                    resistance to Imatinib based on these mutations and does not include all intronic and non-coding regions.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Mutations below the detection limits of the assay may not be detected. Typical detection limit for Sanger
                                    Sequencing assays is &gt;20%.
                                </p>
                            </li>
                            <li>
                                <p>
                                    This test detects mutations in the ABL kinase domain of the BCR-ABL transcript and This report only includes
                                    variants that meets a level of evidence threshold for cause or contribute to disease. Test results are interpreted in
                                    the context of clinical & pathological findings and laboratory data.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Gene transcript used for clinical reporting generally represents the canonical transcript, which is usually the
                                    longest coding transcript with strong/multiple supporting evidence.
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div style={{ width: "97%", marginLeft: "10px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "4px", padding: "8px" }} className="clinical__subheadin">DISCLAIMER</h6>
                    </div>
                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "20px", fontSize: "18px" }}>
                        <br />
                        <ul>
                            <li>
                                <p>Test has been performed assuming that the sample received belongs to the above-named individual(s) and that any
                                    stated relationships between individuals are accepted as true.</p>
                            </li>
                            <li>
                                <p>
                                    The results should be interpreted in the context of the patient’s medical evaluation. Mutation identified in this gene
                                    does not guarantee activity of the drug in a given indication due to presence of contraindicated mutation in gene.
                                </p>
                            </li>
                            <li>
                                <p>
                                    The mutation information provided should only be utilized as a guide or aid and the decision to select any therapy
                                    option based on the information reported here resides solely with the discretion of the treating physician.
                                </p>
                            </li>
                            <li>
                                <p>
                                    This report should only be used as an aid and the treating physician should employ sound clinical judgment in
                                    arriving at any decision for patient care or treatment.
                                </p>
                            </li>
                        </ul>
                    </div>

                    <div style={{ width: "97%", marginLeft: "10px" }}>
                        <h6 style={{ backgroundColor: "#f5f6f7", textAlign: "left", height: "33px", marginTop: "4px", padding: "8px" }} className="clinical__subheadin">REFERENCE</h6>
                    </div>
                    <br />
                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", fontSize: "18px" }}>
                        <ol style={{ marginLeft: "-22px" }}>

                            <p>1. Soverini, Simona, et al. "Bcr-Abl kinase domain mutation analysis in chronic myeloid leukemia patients treated with
                                tyrosine kinase inihibitors: recommendations from an expert panel on behalf of European LeukemiaNet. " Blood
                                (2011): blood-2010.</p>


                            <p>
                                2. Gorre, Mercedes E., et al. "Clinical resistance to STI-571 cancer therapy caused by BCR-ABL gene mutation or
                                amplification." Science 293.5531 (2001): 876-880.
                            </p>


                            <p>
                                3. Chaitanya, Puligundla Krishna, et al. "The role of mutation testing in patients with chronic myeloid leukemia in
                                chronic phase after imatinib failure and their outcomes after treatment modification: Single-institutional
                                experience over 13 years." Indian journal of medical and paediatric oncology: official journal of Indian Society of
                                Medical & Paediatric Oncology 38.3 (2017): 328.
                            </p>


                        </ol>
                    </div>

                    <p style={{ textAlign: "center" }}>------End Of Report-----</p>

                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>

                    {/* footer section starting */}
                    <div className="page-footer">
                        {/* footer area */}
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>geneticcounselors@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                        className="box"
                                    />
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ marginLeft: "196px", alignItems: "center" }}>

                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                    </div>
                    {
                       
                            uuid && (
                                                                        <div className="hide-section-rating">
                                                                            <NpsRating bookingId={firstP} uuid={uuid} />
                                                                        </div>
                                                                    )
                       
                    }
                </div>
            </div >
        </Grammarly >
    );
};

const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(JakReport);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}
